export default class ZoomAbstract {
    // Protected:
    constructor(cParams) {
        this._manager = cParams.manager;
        this._elementId = cParams.elementId;
    }

    getZoomState() {
        const elementId = this._elementId;
        let chart = document.getElementById(elementId);
        let zoomState = chart.__zoom;
        const existsZoomState = zoomState !== undefined;
        if (existsZoomState) {
            zoomState.k = this.makeIdentityIfInvalid(zoomState.k);
            zoomState.x = this.makeZeroIfInvalid(zoomState.x);
            zoomState.y = this.makeZeroIfInvalid(zoomState.y);
        }
        return zoomState;
    }

    getPreviousZoomState() {
        return this._manager.getPreviousZoomState();
    }

    setZoomState(state) {
        const elementId = this._elementId;
        let chart = document.getElementById(elementId);
        if (chart) {
            chart.__zoom = state;
            this.addStateToHistory();
            this.triggerOnZoomChangeListener();
        }
    }

    triggerOnZoomChangeListener() {
        const funcs = this.getOnZoomChangeFunctions();
        funcs.forEach(func => {
            func(this);
        });
    }

    getOnZoomChangeFunctions() {
        const manager = this._manager;
        const funcs = manager._onZoomChangeFuncs;
        return funcs;
    }

    getNewViewBox(state) {
        const elementId = this._elementId;
        let element = document.getElementById(elementId);
        if (element) {
            const w0 = element.scrollWidth;
            const h0 = element.scrollHeight;
            const k = state.k;
            const x = state.x;
            const y = state.y;
            const width = w0 / k;
            const height = h0 / k;
            const offLeft = -x / k;
            const offTop = -y / k;
            return [offLeft, offTop, width, height];
        }
    }

    makeZeroIfInvalid(a) {
        if (isNaN(a)) a = 0;
        else if (!isFinite(a)) a = 0;
        else if (a === undefined) a = 0;
        return a;
    }

    makeIdentityIfInvalid(a) {
        if (isNaN(a)) a = 1.0;
        else if (!isFinite(a)) a = 1.0;
        else if (a === undefined) a = 1.0;
        else if (a === 0) a = 1.0;
        return a;
    }

    //Private:
    addStateToHistory() {
        const state = this.getZoomState();
        this._manager.addStateToHistory(state);
    }
}
